import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { ConfirmModal } from '../ui';
import projectService from '../../services/projectService';
import Toast from '../Toast';

/**
 * Delete Thread confirm modal.
 * API unchanged: projectService.deleteProjectSession
 */
const DeleteThreadModal = ({ onClose, refetch, _id }) => {
  const [loading, setLoading] = useState(false);
  const { id } = useParams();

  const handleSubmit = async () => {
    const payload = {
      project_id: id,
      session_id: _id,
    };
    setLoading(true);
    try {
      const resp = await projectService.deleteProjectSession(payload);
      Toast({ type: 'success', message: resp?.detail });
      setLoading(false);
      refetch();
      onClose();
    } catch (error) {
      setLoading(false);
      Toast({ type: 'error', message: 'Something went wrong' });
    }
  };

  return (
    <ConfirmModal
      title="Delete Thread"
      message={<p>Are you sure you want to delete this thread? This action cannot be undone.</p>}
      confirmLabel="Delete"
      busyLabel="Deleting..."
      loading={loading}
      onConfirm={handleSubmit}
      onClose={onClose}
    />
  );
};

export default DeleteThreadModal;
